// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 702 ? "core_job" : chunkId) + "." + {"438":"34b4faa7","702":"8f1f8598"}[chunkId] + ".js";
};